import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const InventoryItem = ({ item, onEdit, onDelete, onQuantityAdjust }) => {
  const [isAdjusting, setIsAdjusting] = useState(false);
  const [adjustAmount, setAdjustAmount] = useState('');

  const handleAdjustSubmit = () => {
    const amount = parseFloat(adjustAmount);
    if (!isNaN(amount) && amount !== 0) {
      onQuantityAdjust(item?.id, amount);
      setAdjustAmount('');
      setIsAdjusting(false);
    }
  };

  const handleQuickAdjust = (amount) => {
    onQuantityAdjust(item?.id, amount);
  };

  return (
    <div className="p-4 md:p-5 lg:p-6 hover:bg-muted/50 transition-colors duration-150">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-medium text-foreground mb-1">
            {item?.name}
          </h4>
          <div className="flex items-center gap-4 flex-wrap">
            <div className="flex items-center gap-2">
              <span className="text-lg md:text-xl font-semibold text-foreground data-text">
                {item?.quantity}
              </span>
              <span className="text-xs md:text-sm text-muted-foreground">
                {item?.unit}
              </span>
            </div>
            {item?.lastUsed && (
              <span className="text-xs text-muted-foreground">
                Last used: {new Date(item.lastUsed)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsAdjusting(!isAdjusting)}
            iconName="Calculator"
            aria-label="Adjust quantity"
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(item)}
            iconName="Edit"
            aria-label="Edit item"
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(item?.id)}
            iconName="Trash2"
            aria-label="Delete item"
          />
        </div>
      </div>
      {isAdjusting && (
        <div className="mt-4 p-4 bg-muted rounded-lg border border-border">
          <p className="text-sm font-medium text-foreground mb-3">
            Adjust Quantity
          </p>
          <div className="flex items-center gap-2 mb-3">
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleQuickAdjust(-1)}
              iconName="Minus"
            >
              -1
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleQuickAdjust(-5)}
              iconName="Minus"
            >
              -5
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleQuickAdjust(1)}
              iconName="Plus"
            >
              +1
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleQuickAdjust(5)}
              iconName="Plus"
            >
              +5
            </Button>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="number"
              value={adjustAmount}
              onChange={(e) => setAdjustAmount(e?.target?.value)}
              placeholder="Custom amount"
              className="flex-1 px-3 py-2 text-sm bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
            />
            <Button
              variant="default"
              size="sm"
              onClick={handleAdjustSubmit}
              disabled={!adjustAmount}
            >
              Apply
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                setIsAdjusting(false);
                setAdjustAmount('');
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InventoryItem;